import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import Toggle from 'react-toggle';
import Select from 'react-select';

import { Link, Redirect } from 'react-router-dom';
import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';
import getLocale from '../../i18n/getLocale';

class Fatigue extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',        
      },
      redirect_url: false,
      loaded: 0,
      key: 1,
      fatigue_data: {},
      fatigue_options_data: {},
      applicabilities_list: [],
      types_list: [],
      operators_list: [],
      automation_types_list: [],
      operator: '',
      type: '',
      name: '',
      applicability_id: '',
      automation_type_id: '',
      hour_points: '',
      quantity_points: '',
      point_limit: '',
      option_name: '',
      nocturnal_extra_points: null,
      max_points: null,
      min_points: null,
      reduction_points: null,
      points: '',
      required: 0,
      automatic_field: 0,
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.locale = getLocale();

    this.delete = this.delete.bind(this);
    this.deleteRow = this.deleteRow.bind(this);
    this.addFatigueOption = this.addFatigueOption.bind(this);
    this.edit = this.edit.bind(this);
    this.loadData = this.loadData.bind(this);
  }

  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }
  handleSelectChangeMulti(name, event) {
    var change = {};
    var change2 = {};
    if(event == null) {
      change['applicability_name'] = null;
      change2['applicability_id'] = null;
    } else {
      change['applicability_name'] = event.label;
      change2['applicability_id'] = event.value;
    }
    this.setState(change);
    this.setState(change2);
  }

  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }
  
  handleToggleChange (name, event) {
    var change = {};
    if (event.target.checked === true) {
      var value = 1;
    } else {
      var value = 0;
    }
    change[name] = value;
    this.setState(change);
  } 
  
  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }

  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});      
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  //LM
  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }

  loadData (event) {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/parametro-de-fadiga/'+self.props.match.params.id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url', '/parametros-de-fadiga');
        if (responseJson.status === 'success') {
          self.setState({
            id: responseJson.data.fatigue.id,
            name: responseJson.data.fatigue.name,
            type: responseJson.data.fatigue.type,
            operator: responseJson.data.fatigue.operator,
            hour_points: responseJson.data.fatigue.hour_points,
            quantity_points: responseJson.data.fatigue.quantity_points,
            point_limit: responseJson.data.fatigue.point_limit,
            required: responseJson.data.fatigue.required,
            api_type: responseJson.data.fatigue.api_type,
            automatic_field: responseJson.data.fatigue.automatic_field,
            automation_type: responseJson.data.fatigue.automation_type,
            automation_type_id: responseJson.data.fatigue.automation_type_id,
            limit_extra_hours_week: responseJson.data.fatigue.limit_extra_hours_week,
            limit_extra_hours_month: responseJson.data.fatigue.limit_extra_hours_month,
            day_limit_extra_hours_week: responseJson.data.fatigue.day_limit_extra_hours_week,
            day_limit_extra_hours_month: responseJson.data.fatigue.day_limit_extra_hours_month,
            max_points: responseJson.data.fatigue.max_points,
            nocturnal_extra_points: responseJson.data.fatigue.nocturnal_extra_points,
            min_points: responseJson.data.fatigue.min_points,
            reduction_points: responseJson.data.fatigue.reduction_points,
            applicabilities_list: responseJson.data.applicabilities,
            types_list: responseJson.data.types,
            operators_list: responseJson.data.operators,
            automation_types_list: responseJson.data.automation_types,
            applicability_id: responseJson.data.fatigue.applicability_id,
            applicability_name: responseJson.data.fatigue.applicability_name,
          });
        }
      }).then(() => {
      var url = config.get('api') + '/parametro-de-fadiga/opcoes/'+self.props.match.params.id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({fatigue_options_data: responseJson.data});
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        if (typeof event === 'undefined') {
          self.handleMessage();
        } else {
          self.handleAlert(event.message, event.status, 'open');
        }
      }); /* Overlay */ }); /* Opções da fadiga */
    });
  }

  // Fetch salvando a edição
  edit(event) {
    event.preventDefault();
    this.handleAlert('', '', 'open');
    var datasave = {
      id: this.state.id,
      name: this.state.name,
      type: this.state.type,
      operator: this.state.operator,
      applicability_id: this.state.applicability_id,
      applicability_name: this.state.applicability_name,
      hour_points: this.state.hour_points,
      quantity_points: this.state.quantity_points,
      point_limit: this.state.point_limit,
      required: this.state.required,
      extra_hours: this.state.extra_hours,
      automatic_field: this.state.automatic_field,
      automation_type_id: this.state.automation_type_id,
      nocturnal_extra_points: this.state.nocturnal_extra_points,
      max_points: this.state.max_points,
      min_points: this.state.min_points,
      reduction_points: this.state.reduction_points,
      limit_extra_hours_week: this.state.limit_extra_hours_week,
      limit_extra_hours_month: this.state.limit_extra_hours_month,
      day_limit_extra_hours_week: this.state.day_limit_extra_hours_week,
      day_limit_extra_hours_month: this.state.day_limit_extra_hours_month,      
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/parametro-de-fadiga', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        self.handleAlert(responseJson.message, responseJson.status, 'open');
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  addFatigueOption(event) {
    event.preventDefault();
    this.handleAlert('', '', 'open');
    var datasave = {
      name: this.state.option_name,
      points: this.state.points,
      fatigue_id: this.state.id,
    };
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/parametro-de-fadiga/opcao', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          var data_temp = self.state.fatigue_options_data;
          data_temp.push(responseJson.data);
          self.setState({fatigue_options_data: data_temp});
        }
        self.handleAlert(responseJson.message, responseJson.status, 'open');
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  delete (event) {
    var fatigue_option_id = event.currentTarget.value;
    var confirm = window.confirm(this.locale.Fadigas.EditarFadiga.deletar);
    if (confirm) {
      this.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/parametro-de-fadiga/opcao/' + fatigue_option_id, { method: 'DELETE', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.deleteRow(fatigue_option_id);
            self.loadData();
          }
          self.handleAlert(responseJson.message, responseJson.status, 'open');
        }).catch((error) => {
          console.error(error);
        });
      });      
    }
  }

  deleteRow(fatigue_option_id) {
    var data = this.state.fatigue_options_data;
    data.map(function(dado, index){
      if (dado.id == fatigue_option_id) {
        data.splice(index, 1);
      }
    });
    this.setState({fatigue_options_data: data});
  }

  render() {
    var self = this;
    return (
<div>
  <Topo promptInstall={this.props.promptInstall}></Topo>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  {this.state.redirect_url ? <Redirect to={{pathname: this.state.redirect_url}}/> : ""}
  <div className="container-liquid">
    <div className="conteudo">
      <h3 className="page-title pull-left">{this.locale.Fadigas.EditarFadiga.titulo}</h3>
      <Link to="/parametros-de-fadiga" className="btn btn-default pull-right"><i className="fa fa-chevron-left"></i> {this.locale.general.voltar}</Link>
      <div className="clearfix"></div>
      <hr/>
      <form onSubmit={this.edit}>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Fadigas.EditarFadiga.formulario.Nome}:</label>
              <input type="text" name="name" className="form-control" placeholder={this.locale.Fadigas.EditarFadiga.formulario.placeholder.NomeDoParametroDeFadiga} value={this.state.name} onChange={this.handleChange.bind(this, 'name')} />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Fadigas.EditarFadiga.formulario.Tipo}:</label>
              <Select
                className="form-field-name"
                name="type"
                value={this.state.type}
                searchable={true}
                placeholder={this.locale.Fadigas.EditarFadiga.formulario.placeholder.SelecionarCliente}
                onChange={this.handleSelectChange.bind(this, 'type')}
                options={this.state.types_list}
              />
            </div>
          </div>
        </div>

        {(this.state.type !== 'text') ?
          <div>
            <div className="row">
              <div className="col-md-6">
                <div className="form-group">
                  <label>{this.locale.Fadigas.EditarFadiga.formulario.Operador}:</label>
                  <Select
                    className="form-field-name"
                    name="operator"
                    value={this.state.operator}
                    searchable={true}
                    placeholder={this.locale.Fadigas.EditarFadiga.formulario.placeholder.SelecionarCliente}
                    onChange={this.handleSelectChange.bind(this, 'operator')}
                    options={this.state.operators_list}
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <label>{this.locale.Fadigas.EditarFadiga.formulario.PontosPorHora}:</label>
                  <input type="text" name="hour_points" className="form-control" placeholder={this.locale.Fadigas.EditarFadiga.formulario.placeholder.QuantidadeDePontosPorHora} value={this.state.hour_points} onChange={this.handleChange.bind(this, 'hour_points')} />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6">
                <div className="form-group">
                  <label>{this.locale.Fadigas.EditarFadiga.formulario.PontosPorQuantidade}:</label>
                  <input type="text" name="quantity_points" className="form-control" placeholder={this.locale.Fadigas.EditarFadiga.formulario.placeholder.QuantidadeDePontosPorQuantidade} value={this.state.quantity_points} onChange={this.handleChange.bind(this, 'quantity_points')} />
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <label>{this.locale.Fadigas.EditarFadiga.formulario.LimiteDePontos}:</label>
                  <input type="text" name="point_limit" className="form-control" placeholder={this.locale.Fadigas.EditarFadiga.formulario.placeholder.LimiteDePontosDoParametro} value={this.state.point_limit} onChange={this.handleChange.bind(this, 'point_limit')} />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6">
                <div className="form-group">
                  <label>{this.locale.Fadigas.EditarFadiga.formulario.PontuacaoExtraPorHoraNoturna}:</label>
                  <input type="text" name="nocturnal_extra_points" className="form-control" placeholder={this.locale.Fadigas.EditarFadiga.formulario.placeholder.PontuacaoExtraPorHoraNoturna} value={this.state.nocturnal_extra_points} onChange={this.handleChange.bind(this, 'nocturnal_extra_points')} />
                </div>
              </div>
            </div>


          </div>    
          : ''
          }
        


        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Fadigas.EditarFadiga.formulario.AplicabilidadeTipoDeColaborador}:</label>
              <Select
                className="form-field-name"
                name="applicability_id"
                value={this.state.applicability_id}
                searchable={true}
                required
                placeholder={this.locale.Fadigas.EditarFadiga.formulario.placeholder.SelecionarAplicabilidade}
                onChange={this.handleSelectChangeMulti.bind(this, 'applicability_id')}
                options={this.state.applicabilities_list}
              />
            </div>
          </div>
          {this.state.applicability_id == 1 || this.state.type == 'text' ? 
            '' :
            <div className="col-md-6">
              <div className="form-group">
                <label>{this.locale.Fadigas.EditarFadiga.formulario.PontosAReduzirParaTreinamento}:</label>
                <input type="text" name="reduction_points" className="form-control" placeholder={this.locale.Fadigas.EditarFadiga.formulario.placeholder.SelecionarAplicabilidade} value={this.state.reduction_points} onChange={this.handleChange.bind(this, 'reduction_points')} />
              </div>
            </div>
          }
        </div>
        <div className="row">
          <div className="col-md-3">
            <div className="form-group">
              <label>{this.locale.Fadigas.EditarFadiga.formulario.ParametroObrigatorio}?</label>
              <br/>
              <Toggle
                checked={this.state.required}
                aria-label='No label tag'
                name="required"
                onChange={this.handleToggleChange.bind(this, 'required')} />
            </div>
          </div>
          <div className="col-md-3">
            <div className="form-group">
              <label>{this.locale.Fadigas.EditarFadiga.formulario.ParametroAutomatico}?</label>
              <br/>
              <Toggle
                checked={this.state.automatic_field}
                aria-label='No label tag'
                name="extra_hours"
                onChange={this.handleToggleChange.bind(this, 'automatic_field')} />
            </div>
          </div>
          {(this.state.automatic_field === 1) ?
            <div className="col-md-6">
              <div className="form-group">
                <label>{this.locale.Fadigas.EditarFadiga.formulario.TipoDeAutomacao}:</label>
                <Select
                  className="form-field-name"
                  name="automation_type"
                  value={this.state.automation_type_id}
                  searchable={true}
                  placeholder={this.locale.Fadigas.EditarFadiga.formulario.placeholder.SelecionarTipo}
                  onChange={this.handleSelectChange.bind(this, 'automation_type_id')}
                  options={this.state.automation_types_list}
                />
              </div>
            </div>
            : ''
          }
        </div>
        {(this.state.type !== 'text') ?
          <div>
            <hr/>
            <h4>{this.locale.Fadigas.EditarFadiga.formulario.tituloAlertas}</h4>
            <hr/>
            <div className="row">
              <div className="col-md-6">
                <div className="form-group">
                  <label>{this.locale.Fadigas.EditarFadiga.formulario.LimiteMaximoDePontos}:</label>
                  <input type="text" name="max_points" className="form-control" placeholder={this.locale.Fadigas.EditarFadiga.formulario.placeholder.LimiteMaximoDePontos} value={this.state.max_points} onChange={this.handleChange.bind(this, 'max_points')} />
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <label>{this.locale.Fadigas.EditarFadiga.formulario.LimiteMinimoDePontos}:</label>
                  <input type="text" name="min_points" className="form-control" placeholder={this.locale.Fadigas.EditarFadiga.formulario.placeholder.LimiteMinimoDePontos} value={this.state.min_points} onChange={this.handleChange.bind(this, 'min_points')} />
                </div>
              </div>
            </div>
          </div>
          : ''
        }        
        {(this.state.automation_type === 'extra_hours' && this.state.api_type === 'rubi') ?
          <div className="row">
            <div className="col-md-6">
              <div className="form-group">
                <label>{this.locale.Fadigas.EditarFadiga.formulario.LimiteDePontosDeHoraExtraPorSemana}:</label>
                <input type="number" name="limit_extra_hours_week" className="form-control" placeholder="" value={this.state.limit_extra_hours_week} onChange={this.handleChange.bind(this, 'limit_extra_hours_week')} />
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group">
                <label>{this.locale.Fadigas.EditarFadiga.formulario.LimiteDePontosDeHoraExtraPorMes}:</label>
                <input type="number" name="limit_extra_hours_month" className="form-control" placeholder="" value={this.state.limit_extra_hours_month} onChange={this.handleChange.bind(this, 'limit_extra_hours_month')} />
              </div>
            </div>
          </div>
          : ''
        }

        {(this.state.automation_type === 'extra_hours' && this.state.api_type === 'rubi') ?
          <div className="row">
            <div className="col-md-6">
              <div className="form-group">
                <label>{this.locale.Fadigas.EditarFadiga.formulario.LimiteDeDiasComHoraExtraPorSemana}:</label>
                <input type="number" name="day_limit_extra_hours_week" className="form-control" placeholder="" value={this.state.day_limit_extra_hours_week} onChange={this.handleChange.bind(this, 'day_limit_extra_hours_week')} />
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group">
                <label>{this.locale.Fadigas.EditarFadiga.formulario.LimiteDeDiasComHoraExtraPorMes}:</label>
                <input type="number" name="day_limit_extra_hours_month" className="form-control" placeholder="" value={this.state.day_limit_extra_hours_month} onChange={this.handleChange.bind(this, 'day_limit_extra_hours_month')} />
              </div>
            </div>
          </div>        
          : ''
        }

        <div className="row">
          <div className="col-md-12">
            <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> {this.locale.general.salvar}</button>
          </div>
        </div>
      </form>
      {(this.state.type === 'options') ?
          <div>
            <hr/>
            <h3>{this.locale.Fadigas.EditarFadiga.tituloAdicionarOpcoes}</h3>
            <hr/>
            <div>
              <form onSubmit={this.addFatigueOption}>
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <label>{this.locale.Fadigas.EditarFadiga.formularioAdicionarOpcoes.Nome}:</label>
                      <input type="text" name="option_name" className="form-control" placeholder={this.locale.Fadigas.EditarFadiga.formularioAdicionarOpcoes.placeholder.NomeDoParametroDeFadiga} value={this.state.option_name} onChange={this.handleChange.bind(this, 'option_name')} />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label>{this.locale.Fadigas.EditarFadiga.formularioAdicionarOpcoes.Pontos}:</label>
                      <input type="text" name="points" className="form-control" placeholder={this.locale.Fadigas.EditarFadiga.formularioAdicionarOpcoes.placeholder.QuantidadeDePontos} value={this.state.points} onChange={this.handleChange.bind(this, 'points')} />
                    </div>
                  </div>
                </div>                  
                <div className="row">
                  <div className="col-md-12">
                    <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> {this.locale.general.salvar}</button>
                  </div>
                </div>
              </form>
            </div>
            <hr/>
            <h4>{this.locale.Fadigas.EditarFadiga.tituloOpcoes}</h4>
            <table className="table">
              <thead>
                <tr>
                  <th>
                    #
                  </th>
                  <th>
                    {this.locale.Fadigas.EditarFadiga.tabela.Opcao}
                  </th>
                  <th>
                    {this.locale.Fadigas.EditarFadiga.tabela.Pontos}
                  </th>
                  <th className='col-md-1'>{this.locale.Fadigas.EditarFadiga.tabela.Acoes}</th>
                </tr>
              </thead>
              <tbody id="frotas">
                {Object.keys(self.state.fatigue_options_data).map(function(k) {
                  return (
                    <tr>
                      <td>
                        {self.state.fatigue_options_data[k].id}
                      </td>
                      <td>
                        {self.state.fatigue_options_data[k].name}
                      </td>
                      <td>
                        {self.state.fatigue_options_data[k].points}
                      </td>
                      <td>
                        <button className="btn btn-sm btn-danger" value={self.state.fatigue_options_data[k].id} onClick={self.delete}>
                          <i className="fa fa-fw fa-trash"></i>
                        </button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>        
          : ''
      }
      
    </div>
  </div>
</div>
    );
  }
}

export default Fatigue;



// WEBPACK FOOTER //
// ./src/Components/Fatigue/FatigueEdit.js